import { NgModule } from '@angular/core';
import { SuggestionCardComponent } from '@app/shared/ui/components/suggestion-card/suggestion-card.component';
import { UiModule } from '@ui';
import { NewDropdownModule } from '@app/shared/ui/components/inputs/new-dropdown/module/new-dropdown.module';

@NgModule({
	declarations: [SuggestionCardComponent],
	imports: [UiModule, NewDropdownModule],
	exports: [SuggestionCardComponent]
})
export class SuggestionCardModule {}
